import { DownloadedContentSourceLocationEnum } from "../enum/DownloadedContentSourceLocationEnum";

export class DownloadRateVO {
    public timeInS: number;
    public sizeInKB: number;
    public name: string;
    public sourceLocation: DownloadedContentSourceLocationEnum;

    public toString(): string {
        return "DownloadRateVO{timeInS=" + String(this.timeInS) + ",sizeInKB=" + String(this.sizeInKB) + ",name=" + String(this.name) + ",sourceLocation=" + String(this.sourceLocation.name) + "}";
    }
}
